import * as Yup from 'yup'
import dayjs from 'dayjs'

export const ApproveStepFormSchema = Yup.object().shape({
  effectiveAt: Yup.string().nullable(),
  expiresAt: Yup.string()
    .nullable()
    .test(
      'expires-after-effective',
      'Expiration date must be after effective date',
      (value, context) => {
        if (!value) {
          return true
        }

        const { effectiveAt } = context.parent

        if (!effectiveAt) {
          return true
        }

        return dayjs(value).isAfter(dayjs(effectiveAt), 'day')
      },
    ),
})
